import * as React from "react";
import { CreateAction } from "./Actions/CreateAction";
import { EditAction } from "./Actions/EditAction";
import { DeleteAction } from "./Actions/DeleteAction";
import { useArrayState } from "../../../hooks/use_array_state";
import { IAutomation } from "../../../config/automation";
import { useGlobalStores } from "../../../hooks/use_global_stores";
import { List } from "../../Components/Admin/List/List";
import { useLabelProvider } from "../../../helpers/automations/label_provider";
import { PageItem } from "../../Components/PageItem";
import { NoAutomations } from "./Components/NoAutomations";

export const Automations = () => {
    const { automationStore } = useGlobalStores();
    const { getLabel } = useLabelProvider();
    const {values, pushValue, updateValue, deleteValue} = useArrayState<IAutomation>(automationStore.automations);

    const handleCreate = (value: IAutomation) => {
        pushValue(value);
        automationStore.addAutomation(value);
    };

    const handleUpdate = (index: number) => (value: IAutomation) => {
        updateValue(index)(value);
        automationStore.replaceAutomation(value);
    };

    const handleDelete = (index: number) => () => {
        deleteValue(index)();
        automationStore.removeAutomation(values[index]);
    };

    const handleNoResultsCTAClick = () => {
        (window.document.getElementsByClassName('add-new-automation-cta')[0] as any).click();
    };

    if (!values.length) {
        return (
            <>
                <NoAutomations onClick={handleNoResultsCTAClick} />
                <div style={{display: 'none'}}><CreateAction onSave={handleCreate} /></div>
            </>
        );
    }

    return (
        <PageItem
            title="Automations"
            actions={<CreateAction onSave={handleCreate} />}
        >
            <List<IAutomation>
                items={values}
                primaryGetter={(v) => {
                    const { action, value } = getLabel(v);
                    return `${action} (${value})`;
                }}
                secondaryGetter={(v) => {
                    const { typeDescription } = getLabel(v);
                    return typeDescription;
                }}
                // iconGetter={(income) => income.name[0]}
                groupBy={(v) => v.type}
                groupHeaderLabel={(v) => {
                    const { type } = getLabel(v);
                    return type;
                }}
                actions={(v, index) => [
                    [EditAction, {value: v, onSave: handleUpdate(index)}],
                    [DeleteAction, {value: v, onDelete: handleDelete(index)}],
                ]}
            />
        </PageItem>
    );
};
